import Vue from "vue";
import * as FullStory from "@fullstory/browser";

// reference: https://www.npmjs.com/package/@fullstory/browser

var isDevelopment = process.env.NODE_ENV === "development";
var isSignedUrl = !!window.location.search && window.location.search.indexOf("X-APP-SIGNED-") > -1;
var isTestsApp = window.location.hostname.startsWith("tests.");
var devMode = isDevelopment || (isSignedUrl && !isTestsApp);

FullStory.init({
  orgId: "Y60WM",
  devMode: devMode,
});

Vue.prototype.$FullStory = FullStory;

export default {};
